export interface UiLanguageOption {
  code: string;
  nativeName: string;
}

export const AVAILABLE_UI_LANGUAGES: UiLanguageOption[] = [
  {code: 'en', nativeName: 'English'},
  {code: 'sv', nativeName: 'Svenska'},
  {code: 'hu', nativeName: 'Magyar'},
  {code: 'de', nativeName: 'Deutsch'}
];
